import React from "react";
import { Navbar } from "../Navbar/Navbar";
import { ThemeContext } from "../../Context/theme";

import "./Header.css";
export const Header = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <header className={"header center " + themename}>
        <h4>
          <a href="#home" className="link">
            Kshitij
          </a>
        </h4>
        <Navbar />
      </header>
    </>
  );
};
